import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import './i18n/config';
import { VideoPreloader } from './components/VideoPreloader';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { ServicesSection } from './components/ServicesSection';
import { ProcessSection } from './components/ProcessSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PDFViewerSection } from './components/PDFViewerSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
import { TermsConditions } from './pages/TermsConditions';
import { Disclaimer } from './pages/Disclaimer';

const HomePage = ({ showPreloader, onPreloaderComplete }) => (
  <>
    {showPreloader && <VideoPreloader onComplete={onPreloaderComplete} />}
    <Header />
    <HeroSection />
    <IntroSection />
    <ServicesSection />
    <ProcessSection />
    <SocialProofSection />
    <PDFViewerSection />
    <FAQSection />
    <Footer />
  </>
);

function App() {
  const [showPreloader, setShowPreloader] = useState(true);
  const [chatbotLoaded, setChatbotLoaded] = useState(false);

  // Load Voiceflow chatbot ONLY after preloader completes
  useEffect(() => {
    if (!showPreloader && !chatbotLoaded) {
      // Wait a bit for the page to render, then load chatbot
      const loadChatbotTimer = setTimeout(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
          (function(d, t) {
            var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
            v.onload = function() {
              window.voiceflow.chat.load({
                verify: { projectID: '690f1b0f9bba17d45b4a4a3c' },
                url: 'https://general-runtime.voiceflow.com',
                versionID: 'production',
                voice: {
                  url: "https://runtime-api.voiceflow.com"
                }
              });
            }
            v.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs";
            v.type = "text/javascript";
            s.parentNode.insertBefore(v, s);
          })(document, 'script');
        `;
        document.body.appendChild(script);
        setChatbotLoaded(true);
      }, 500); // Wait 500ms after preloader ends

      return () => {
        clearTimeout(loadChatbotTimer);
      };
    }
  }, [showPreloader, chatbotLoaded]);

  const handlePreloaderComplete = () => {
    setShowPreloader(false);
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage showPreloader={showPreloader} onPreloaderComplete={handlePreloaderComplete} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </div>
  );
}

export default App;